import React, {Component} from "react";
import {ReactSVG} from "react-svg";
import {Translate} from "react-i18nify";

import Input from "./Input";

import imgCancel from "../../../resources/img/svgicons/close3.svg";
import imgLoader from "../../../resources/img/loader.svg";

export default class SearchInputSelectBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterInput: "",
            isFocused: false
        };
    }

    handleFocus = () => {
        this.setState({isFocused: true});
    };

    isSelectActive = () => {
        if (this.state.isFocused) {
            return "active";
        }
        return "";
    };

    handleSelectFilterClick = (event) => {
        this.props.valueSelected(
            this.props.optionsList.find((option) => option.id === Number(event.target.dataset.name))
        );
        this.setState({filterInput: ""});
    };

    getActiveSelectBoxWithKey = () => {
        let itemList = [];
        let index = 0;
        let inputName = this.state.filterInput;

        if (this.props.loading) {
            return (
                <div className="flex search-panel-loader flex-align-center col-12">
                    <img alt="loading" src={imgLoader} />
                </div>
            );
        }

        if (this.props.optionsList.length === 0) {
            return <li>{<Translate value="mainTab.noResultsFound" />}</li>;
        }

        for (let item of this.props.optionsList) {
            if (inputName === "" || item.name.toLowerCase().includes(inputName.toLowerCase())) {
                itemList.push(
                    <li
                        className={index === this.state.isFocused ? "select-box-item active" : "select-box-item"}
                        key={index}
                        data-name={item.id}
                        onMouseDown={this.handleSelectFilterClick}
                        {...item.elementProps}
                    >
                        {item.rgb ? <div className="color-square" style={{backgroundColor: item.rgb}} /> : ""}
                        {item[this.props.property ?? "name"]}
                    </li>
                );
            }

            index++;
        }

        return itemList;
    };

    handleBlur = () => {
        this.setState({isFocused: false});
    };

    handleChange = (event) => {
        this.props.onChange(event.target.value);
        this.setState({filterInput: event.target.value});
    };

    handleRemoveSelected = () => {
        this.props.valueSelected(null);
    };

    render() {
        return (
            <div className="col-12">
                {this.props.label && (
                    <div className="pull-right select-box-description color-primary">
                        <span className="font-size-1_25em">{this.props.label}</span>
                    </div>
                )}
                <div
                    className={
                        "col-12 general-multiselect-box primary-multiselect-box select-box search-select-box" +
                        (this.props.disabled ? " disabled" : "")
                    }
                >
                    <Input
                        labelBefore={
                            this.props.selectedValue ? (
                                <div className="flex">
                                    <ReactSVG
                                        className="cursor-pointer"
                                        style={{height: "20px"}}
                                        src={imgCancel}
                                        onClick={this.handleRemoveSelected}
                                    />
                                </div>
                            ) : null
                        }
                        value={
                            this.state.isFocused
                                ? this.state.filterInput
                                : this.props.selectedValue?.[this.props.property ?? "name"] ?? ""
                        }
                        placeholder={this.props.placeholder}
                        className="col-12"
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        onChange={this.handleChange}
                        disabled={this.props.disabled}
                    />
                    <div className={"search-select-box-items select-box-list " + this.isSelectActive()}>
                        <ul className="filtering-select-box slim-scroll">{this.getActiveSelectBoxWithKey()}</ul>
                    </div>
                </div>
            </div>
        );
    }
}
